export default __webpack_public_path__ + "static/O0161-abc4a33ce93d6ae8d9a1a5361f48f679.png";